import {
  FC,
  SelectHTMLAttributes,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react'
import { FaCheck } from 'react-icons/fa6'
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io'

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  setStatedSelectedOption: React.Dispatch<React.SetStateAction<string>>
  selectedOption: string
  optionsList: { value: string; label: string }[]
}

export const SelectStatus: FC<SelectProps> = ({
  optionsList,
  setStatedSelectedOption,
  selectedOption,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement | null>(null)

  const handleOptionClickStatus = (value: SetStateAction<string>) => {
    // se for igual ao valor atual, volta para o valor inicial
    if (selectedOption === value) {
      setStatedSelectedOption('Status')
      setIsOpen(false)
      return
    }
    setStatedSelectedOption(value)
    setIsOpen(false)
  }

  useEffect(() => {
    function handleClickOutsideAddEmployee(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutsideAddEmployee)

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideAddEmployee)
    }
  }, [])

  return (
    <div className="relative w-1/2" ref={dropdownRef}>
      <button
        type="button"
        className="
          w-full h-12 border border-neutral-200 dark:border-neutral-700
          rounded-full px-4 hover:border-[#4F46E5] focus:border-[#4F46E5]
          hover:dark:border-[#4F46E5] focus:dark:border-[#4F46E5]
          flex items-center justify-between cursor-pointer bg-white dark:bg-neutral-900
        "
        onClick={() => setIsOpen(!isOpen)}
      >
        <p className="text-neutral-900 dark:text-white">{selectedOption}</p>
        {isOpen ? (
          <IoIosArrowDown className="w-4 h-4 fill-current text-gray-700 dark:text-neutral-100 ml-2" />
        ) : (
          <IoIosArrowForward className="w-4 h-4 fill-current text-gray-700 dark:text-neutral-100 ml-2" />
        )}
      </button>
      {isOpen && (
        <div
          className="
            absolute z-10 mt-2 w-full bg-white dark:bg-neutral-900
            shadow-lg rounded-2xl border-[0.05rem] border-neutral-200/70
            overflow-hidden dark:border-neutral-700
          "
        >
          {optionsList.map((option) => (
            <button
              type="button"
              key={option.value}
              className={`
                px-4 py-2 w-full hover:bg-[#4F46E5]/20 bg-white
                dark:hover:bg-[#4F46E5]/80 dark:bg-[#4F46E5]
                cursor-pointer text-left flex items-center
                dark:text-white ${selectedOption === option.value ? 'bg-[#4F46E5]/20' : ''}
                ${selectedOption === option.value ? 'text-[#4F46E5]' : ''}
              `}
              onClick={() => handleOptionClickStatus(option.value)}
            >
              {option.label}
              {selectedOption !== 'Status' &&
                selectedOption === option.value && (
                  <FaCheck className="w-4 h-4 ml-auto" />
                )}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
